'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useClerk } from '@clerk/nextjs';
import { segmentClient } from '@/lib/analytics/segment';
import { FullscreenOverlay } from './new-ui/FullscreenOverlay';
import { DISCORD_INVITE_URL } from '@/lib/links';

const PreGameMenuButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();
  const { signOut } = useClerk();

  const toggleMenu = () => setIsOpen((prev) => !prev);

  const handleManageSubscription = async () => {
    segmentClient.track('Button Pressed', {
      choiceValue: 'Manage Subscription',
      eventCategory: 'game setup',
      eventSubCategory: 'manage-subscription',
    });
    // Open Stripe's customer portal for subscription management
    window.open(process.env.NEXT_PUBLIC_STRIPE_BILLING_PORTAL_URL, '_blank');
  };

  const handleLogOut = async () => {
    segmentClient.track('Button Pressed', {
      choiceValue: 'Log Out',
      eventCategory: 'game setup',
      eventSubCategory: 'log-out',
    });
    try {
      await signOut({ redirectUrl: '/' });
    } catch {
      router.push('/');
    }
  };

  const handleJoinDiscord = () => {
    segmentClient.track('Button Pressed', {
      choiceValue: 'Join Discord',
      eventCategory: 'game setup',
    });
    window.open(DISCORD_INVITE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="absolute top-5 right-5 z-[100]">
      <button
        onClick={toggleMenu}
        className="w-12 h-12 bg-black/40 rounded-full flex items-center justify-center hover:bg-black/60 hover:scale-110 hover:shadow-xl transition-all duration-200 ease-in-out"
        aria-label="Open menu"
        type="button"
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="white" />
        </svg>
      </button>

      <FullscreenOverlay visible={isOpen} onClose={toggleMenu}>
        <div className="flex flex-col items-center gap-6 mt-20">
          <button
            className="rounded-[86px] bg-white/10 border border-[#5865F2]/30 backdrop-blur-md w-full max-w-[520px] h-[56px] text-white text-[22px] font-bold transition-all duration-200 hover:bg-white/15 hover:scale-105 shadow-[0_0_0_1px_rgba(255,255,255,0.08),0_12px_40px_rgba(88,101,242,0.16)]"
            onClick={handleJoinDiscord}
            type="button"
          >
            <span className="inline-flex items-center justify-center gap-3">
              <Image
                src="/game_ui/discord.svg"
                alt="Discord"
                width={24}
                height={24}
                className="h-6 w-6"
              />
              <span>Join our Discord</span>
            </span>
          </button>
          <button
            className="rounded-[86px] bg-white/10 backdrop-blur-md w-full max-w-[520px] h-[56px] text-white text-[22px] font-bold transition-all duration-200 hover:bg-white/15 hover:scale-105"
            onClick={handleManageSubscription}
            type="button"
          >
            Manage Subscription
          </button>
          <button
            className="rounded-[86px] bg-white/10 backdrop-blur-md w-full max-w-[520px] h-[56px] text-white text-[22px] font-bold transition-all duration-200 hover:bg-white/15 hover:scale-105"
            onClick={handleLogOut}
            type="button"
          >
            Log Out
          </button>
        </div>
      </FullscreenOverlay>
    </div>
  );
};

export default PreGameMenuButton;
